/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationSharedCourseListMultipleQueryResponse,
  GetApiV1CourseregistrationSharedCourseListMultipleQueryParams,
  GetApiV1CourseregistrationSharedCourseListMultiple401,
  GetApiV1CourseregistrationSharedCourseListMultiple500,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedCourseListMultiple.ts";

function getGetApiV1CourseregistrationSharedCourseListMultipleUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/shared/course-list-multiple` as const,
  };
  return res;
}

/**
 * @description Retorna cursos ativos filtrados por texto, empresa e opcionalmente por polo. A chave retornada tem o prefixo 'GRP' (ex.: 'GRP123'). Usuários com papel Polo recebem apenas cursos vinculados aos seus polos. A empresa do usuário autenticado sobrepõe o parâmetro 'companyId' quando aplicável. Quando 'includeRelationShip' é verdadeiro, inclui cursos associados à empresa via tabela de relacionamento. **(Requer Authorization para autenticação)**
 * @summary Retorna lista de cursos para seleção múltipla (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/shared/course-list-multiple}
 */
export async function getApiV1CourseregistrationSharedCourseListMultiple(
  params?: GetApiV1CourseregistrationSharedCourseListMultipleQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationSharedCourseListMultipleQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedCourseListMultiple401
      | GetApiV1CourseregistrationSharedCourseListMultiple500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationSharedCourseListMultipleUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
